// Word-level diff of two texts. jsdiff's own diffWords treats Cyrillic letters
// as non-word characters (so «классицистический» → «классический» came out as
// a change inside the word); here the texts are cut into word / space /
// punctuation tokens with Unicode classes and the token lists are diffed.
// Shared by the server (text_edit measures the edit) and the browser (the
// Before / After columns).
const { diffArrays } = require('diff');

const TOKEN_RE = /[\p{L}\p{N}́]+|\s+|[^\p{L}\p{N}\ś]+/gu;
const tokens = (s) => String(s || '').match(TOKEN_RE) || [];
const isWord = (t) => /[\p{L}\p{N}]/u.test(t);

// -> [{ v, a, r }]: the text in order; a = added, r = removed, neither = common.
function wordDiff(before, after) {
  return diffArrays(tokens(before), tokens(after)).map((p) => ({ v: p.value.join(''), a: !!p.added, r: !!p.removed }));
}

// How many words moved: words inside added or removed parts, and the total.
function wordStats(parts, before, after) {
  const count = (s) => tokens(s).filter(isWord).length;
  const changed = parts.filter((p) => p.a || p.r).reduce((n, p) => n + tokens(p.v).filter(isWord).length, 0);
  return { changed, total: Math.max(count(before), count(after)) };
}

module.exports = { wordDiff, wordStats, tokens };
